const ListStar = ['★', '◆', '●', '▲', '◎', '□', '×', '▽', '']
export default ListStar
